import { newProperty } from "../schema.generator";

const putLayerSchema = [
  { ...newProperty("width", "string", true, "Width") },
  { ...newProperty("height", "string", true, "Height") }
];

export default putLayerSchema;
